import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import styles from './Popup.module.scss';
import {
  Button,
  EButtonHierarchy,
  EButtonSize,
  EButtonStyle,
} from '../Button/Button';
import { ReactComponent as CloseIcon } from '@/assets/icons/actions/close.svg';

type ReactChildrenWithClose = (helpers: {
  close: () => void;
}) => React.ReactNode;
interface IPopupProps {
  hideCloseButton?: boolean;
  disableBackdropClose?: boolean;
  fullWidthOnLaptop?: boolean;
  zIndex?: number;
  popupClassName?: string;
  backdropClassName?: string;
  onClose: () => void;
  children: ReactChildrenWithClose | React.ReactNode;
}
export const Popup: React.FC<IPopupProps> = (props: IPopupProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const onBackdropClick = () => {
    if (!props.disableBackdropClose) {
      closePopup();
    }
  };

  const onCloseClick = () => {
    closePopup();
  };

  const closePopup = () => {
    setIsOpen(false);
    setTimeout(() => {
      props.onClose();
    }, 300);
  };

  useEffect(() => {
    requestAnimationFrame(() => {
      setIsOpen(true);
    });
  }, []);

  const popupClasses = [
    styles.popup,
    props.fullWidthOnLaptop && styles.fullWidthOnLaptop,
    props.popupClassName,
  ]
    .filter(Boolean)
    .join(' ');

  const backdropStyle = props.zIndex ? { zIndex: props.zIndex } : undefined;

  return (
    <div
      className={clsx(
        styles.backdrop,
        isOpen && styles.show,
        props.backdropClassName
      )}
      style={backdropStyle}
      onClick={onBackdropClick}
    >
      <div className={popupClasses} onClick={e => e.stopPropagation()}>
        {!props.hideCloseButton && (
          <div className={styles.closeButtonContainer}>
            <Button
              size={EButtonSize.md}
              hierarchy={EButtonHierarchy.neutral}
              buttonStyle={EButtonStyle.ghost}
              iconLead={CloseIcon}
              onClick={onCloseClick}
            />
          </div>
        )}
        <div className={styles.popupContent}>
          {typeof props.children === 'function' &&
            props.children({ close: closePopup })}
          {typeof props.children === 'object' && props.children}
        </div>
      </div>
    </div>
  );
};
